import bestand from '../../../../shared/gemeenten.json'

/*
 * De suggestielijst voor het gemeenteveld (FR-06).
 *
 * Overgenomen uit de tarieventabel van de bestaande site. Daar bepaalde de
 * gemeente het tarief; sinds WP-08 doet hij dat niet meer, en wat er overblijft is
 * de invulhulp: een handvol namen die het typewerk schelen.
 *
 * DE LIJST BEPAALT NIETS. Staat een gemeente er niet bij, dan typt de bezoeker de
 * naam zelf en gaat de aanvraag gewoon door. De server keurt het veld op inhoud —
 * ingevuld en niet te lang — en niet op deze lijst. Dat is met opzet: zestien van
 * de ruim driehonderd Nederlandse gemeenten mogen niemand tegenhouden.
 *
 * De definitieve lijst is onderdeel van O-02 en blokkeert de livegang via
 * `scripts/verify-tarief.mjs`.
 */

/**
 * De namen, alfabetisch. Het bestand houdt de volgorde van de bestaande site aan
 * — daar is hij vandaan gekomen; hier staat de volgorde waarin hij getoond wordt.
 */
export const gemeenten: readonly string[] = [...bestand.gemeenten].sort(
  (a, b) => a.localeCompare(b, 'nl'),
)

/** True zolang de opdrachtgever de lijst niet heeft vastgesteld (O-02). */
export const gemeentenZijnVoorlopig = bestand.status !== 'definitief'

/** Waar of `waarde` een naam uit de lijst is, hoofdletters en spaties daargelaten. */
export function staatInLijst(waarde: string): boolean {
  const gezocht = waarde.trim().toLocaleLowerCase('nl')

  return gemeenten.some((naam) => naam.toLocaleLowerCase('nl') === gezocht)
}

/** De namen die `zoekterm` bevatten. Leeg zoeken levert de hele lijst. */
export function zoekGemeenten(zoekterm: string): readonly string[] {
  const gezocht = zoekterm.trim().toLocaleLowerCase('nl')
  if (gezocht === '') return gemeenten

  return gemeenten.filter((naam) =>
    naam.toLocaleLowerCase('nl').includes(gezocht),
  )
}
